'use es6';

import { getPromotions } from 'pricing-pages-lib/api/PromotionApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchPromotionsRequestTypes = createRequestTypes('PROMOTIONS');
export const FetchPromotionsActions = createRequestActions(FetchPromotionsRequestTypes);
export const fetchEligiblePromotions = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchPromotionsActions,
    fetch: getPromotions
  })(dispatch);
};